import './App.css';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import { MainContainer, ChatContainer, Message, MessageList, MessageInput, TypingIndicator, ConversationHeader, Avatar } from '@chatscope/chat-ui-kit-react';
import { useState } from 'react';
import React from 'react';
import { ChatRequest } from './message';
import { sendMessage } from './api/openAI';
import Linkify from 'react-linkify';


function App() {
  const [typing, setTyping] = useState(false);
  const [chatRequest, setChatRequest] = React.useState<ChatRequest>({
    lastMessage: undefined,
    cacheMessages:[],
    messages: [{
      role: "assistant",
      content: "Hello there. How can I help you?",
      createdAt: new Date()
    }]
  });
  function htmlToPlainText(htmlContent: string) {
    // Create a temporary HTML element to use the browser's built-in parser
    var tempDiv = document.createElement('div');
    
    // Set the innerHTML to the provided HTML content
    tempDiv.innerHTML = htmlContent;
    
    // Replace <br> tags with newlines
    var textContent = tempDiv.textContent || tempDiv.innerText || '';
    
    // Replace multiple consecutive newlines with a single newline
    textContent = textContent.replace(/\n+/g, '\n').trim();
    
    return textContent;
}

  const handleSend = (message: string) =>{
    const plainMessage = htmlToPlainText(message)
    const newMesage  = {role: "user", content: plainMessage, createdAt: new Date()}
    const newChatRequest: ChatRequest = {...chatRequest, messages: [...chatRequest.messages, newMesage], lastMessage: newMesage}
    setChatRequest(newChatRequest);
    setTyping(true);
    
  }

  React.useEffect(()=>{
    if(typing){
    sendMessage(chatRequest).then((resp)=> {setTyping(false);setChatRequest(resp as ChatRequest);}).catch((error)=>{
      console.log(error);
      setTyping(false);
    })
    }
  },[typing])

   return (
    <div className="App">
      <div style = {{position: "relative", height:"100vh", width :"100vw"}}>
        <MainContainer>
          <ChatContainer>
          <ConversationHeader>
            <Avatar
              name="Chatbot"
              src="https://bestresultsdentalmarketing.com/wp-content/uploads/2024/02/What-is-Artiificial-IntelligenceAI.webp"
            />
            <ConversationHeader.Content
              info="Active Now"
              userName="Chatbot"
            />
          </ConversationHeader>
            <MessageList 
              typingIndicator = {typing ? <TypingIndicator content = "typing..."/> : null}>
              {
                chatRequest.messages.map((message, index)=>{
                  
                  return <Message key = {index} model = {{ position: "normal", sender: message.role, direction: message.role === "user" ? "outgoing": "incoming"}}>
                            <Message.CustomContent>            
                              <Linkify componentDecorator={(decoratedHref, decoratedText, key) => <a target="blank" rel="noopener" href={decoratedHref} key={key}>
                                {decoratedText}
                              </a>}>
                              {message.content}
                              </Linkify>
                            </Message.CustomContent>
                            </Message>
                })
              }
            </MessageList>
            <MessageInput placeholder='Type something' onSend = {handleSend} autoFocus attachButton = {false}  style={{textAlign: "left"}} disabled = {typing}/>
          </ChatContainer>

        </MainContainer>
      </div>
    </div>
  );
}

export default App;
